/** Default page size for card-based record histories and progress lists. */
export const CARD_RECORD_PAGE_SIZE = 15;

/** Default page size for dense record tables and report rows. */
export const DENSE_ROW_PAGE_SIZE = 25;

/** Compact credit summary retained on Family Home. */
export const HOME_CREDIT_PREVIEW_PAGE_SIZE = 3;

/** The Inbox keeps a larger bounded message history inside each conversation. */
export const INBOX_THREAD_MESSAGE_PAGE_SIZE = 50;
